import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React, { useState } from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import { PasswordIcon, SuccessIcon, checkPassword } from '../../utils';
import { apis } from '../../api/index.js';
import _ from 'lodash';

const EditPassword = props => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [passwordState, setPasswordState] = useState('');

  const handleOk = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //保存评价内容
        if (values.newPassword !== values.rePassword) {
          message.warning('两次密码不一致');
        } else if (passwordState <= 1) {
          message.warning('密码强度太弱，账户存在风险，请重新设置密码');
        } else {
          setConfirmLoading(true);
          const post = _.pick(values, ['oldPassword', 'newPassword']);

          apis.modifyPWD(post).then(res => {
            if (res.code === '0') {
              message.success('修改成功，请重新登录！');
              setSuccessful(true);
              setConfirmLoading(false);

              const { passwordNoClose } = props;
              if (passwordNoClose) {
                let { userInfo } = props;
                userInfo = { ...userInfo, needUpdatePwd: false };
                props.onUserInfoUpdated(userInfo);
              }

              setTimeout(() => props.history.push('/login'), 1000);
            } else {
              message.error(res.message);
              setConfirmLoading(false);
            }
          });
        }
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  const handleCancel = changed => {
    props.onCancel(changed);
  };

  const passwordKeyUp = e => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      const modes = checkPassword(values.newPassword);
      setPasswordState(modes);
    });
  };

  const { getFieldDecorator } = props.form;
  const { visible, passwordNoClose } = props;

  const buttons = [];
  if (!passwordNoClose)
    buttons.push(
      <Button
        key="cancel"
        onClick={() => handleCancel(false)}
        type="default"
        className="btn-cancel"
      >
        取消
      </Button>
    );
  buttons.push(
    <Button
      key="submit"
      type="primary"
      onClick={handleOk}
      className="btn-ok"
      loading={confirmLoading}
    >
      确认修改
    </Button>
  );
  return (
    <Modal
      title="修改密码"
      visible={visible}
      width={800}
      onCancel={() => handleCancel(false)}
      closable={!props.passwordNoClose}
      footer={buttons}
      className="help-dialog"
      centered
      maskClosable={false}
      keyboard={false}
    >
      <div className="edit-password-modal">
        {/* 弹出框 */}
        {successful ? (
          <div className="edit-success">
            <div className="icon">
              <SuccessIcon />
            </div>
            <div className="text">
              密码修改成功<span>返回工作站</span>
            </div>
          </div>
        ) : (
          <Form>
            <Form.Item label="" colon={false}>
              {getFieldDecorator('oldPassword', {
                rules: [{ required: true, message: '请输入原始密码' }],
              })(
                <Input.Password
                  prefix={<PasswordIcon />}
                  placeholder="旧密码"
                  size="large"
                />
              )}
            </Form.Item>
            <Form.Item label="" colon={false}>
              {getFieldDecorator('newPassword', {
                rules: [{ required: true, message: '请输入密码' }],
              })(
                <Input.Password
                  prefix={<PasswordIcon />}
                  placeholder="新密码"
                  size="large"
                  onKeyUp={passwordKeyUp}
                />
              )}
              <div className="password-status">
                <span className={passwordState >= 1 ? 's1' : ''}>弱</span>
                <span className={passwordState >= 2 ? 's2' : ''}>中</span>
                <span className={passwordState >= 3 ? 's3' : ''}>强</span>
                <span className={passwordState >= 4 ? 's4' : ''}>很强</span>
              </div>
            </Form.Item>

            <Form.Item label="" colon={false}>
              {getFieldDecorator('rePassword', {
                rules: [{ required: true, message: '请确认密码' }],
              })(
                <Input.Password
                  prefix={<PasswordIcon />}
                  placeholder="确认密码"
                  size="large"
                />
              )}
            </Form.Item>
          </Form>
        )}
        <div className="edit-tips">
          其他问题可联系客服。客服电话<span>400-886-9793</span>
        </div>
      </div>
    </Modal>
  );
};
EditPassword.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object,
  history: PropTypes.object,
  passwordNoClose: PropTypes.bool,
  userInfo: PropTypes.object,
  onUserInfoUpdated: PropTypes.func,
};
export default withRouter(Form.create()(EditPassword));
